import * as React from "react";
const SvgFiRrWater = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-water_svg__a)">
      <path
        fill="#062147"
        d="M21 23a4.38 4.38 0 0 1-3-1.225 4.336 4.336 0 0 1-6 0 4.336 4.336 0 0 1-6 0 4.186 4.186 0 0 1-5.668.2 1.001 1.001 0 0 1 .999-1.693 1 1 0 0 1 .336.204 2.2 2.2 0 0 0 3.388-.817 1.006 1.006 0 0 1 1.89 0 2.278 2.278 0 0 0 4.11 0 1.008 1.008 0 0 1 1.89 0 2.278 2.278 0 0 0 4.11 0 1.006 1.006 0 0 1 1.89 0 2.2 2.2 0 0 0 3.387.817 1 1 0 0 1 1.336 1.487A3.98 3.98 0 0 1 21 23m0-6a4.38 4.38 0 0 1-3-1.225 4.336 4.336 0 0 1-6 0 4.336 4.336 0 0 1-6 0 4.186 4.186 0 0 1-5.668.2 1.001 1.001 0 0 1 .999-1.693 1 1 0 0 1 .336.204 2.2 2.2 0 0 0 3.388-.817 1.006 1.006 0 0 1 1.89 0 2.278 2.278 0 0 0 4.11 0 1.007 1.007 0 0 1 1.89 0 2.278 2.278 0 0 0 4.11 0 1.007 1.007 0 0 1 1.89 0 2.2 2.2 0 0 0 3.387.817 1 1 0 0 1 1.336 1.487A3.98 3.98 0 0 1 21 17m0-6a4.38 4.38 0 0 1-3-1.225 4.336 4.336 0 0 1-6 0 4.336 4.336 0 0 1-6 0 4.186 4.186 0 0 1-5.668.2 1 1 0 1 1 1.335-1.486 2.2 2.2 0 0 0 3.388-.817 1.006 1.006 0 0 1 1.89 0 2.278 2.278 0 0 0 4.11 0 1.008 1.008 0 0 1 1.89 0 2.279 2.279 0 0 0 4.11 0 1.007 1.007 0 0 1 1.89 0 2.2 2.2 0 0 0 3.387.817 1 1 0 0 1 1.336 1.487A3.98 3.98 0 0 1 21 11m0-6a4.38 4.38 0 0 1-3-1.225 4.336 4.336 0 0 1-6 0 4.336 4.336 0 0 1-6 0 4.186 4.186 0 0 1-5.668.2 1 1 0 1 1 1.335-1.486 2.2 2.2 0 0 0 3.388-.817 1.006 1.006 0 0 1 1.89 0 2.278 2.278 0 0 0 4.11 0 1.008 1.008 0 0 1 1.875-.041l.015.042a2.278 2.278 0 0 0 4.11 0 1.008 1.008 0 0 1 1.89 0 2.2 2.2 0 0 0 3.387.817 1 1 0 1 1 1.336 1.487A3.98 3.98 0 0 1 21 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-water_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWater;
